import { useEffect, useRef } from "react";
import { useStore } from "@/store";
import { PageMode } from "@/store/types";
import { getAssetUrl } from "@/utils/common";
import styles from './index.module.scss';

const HomeBgVideo = () => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const mode = useStore((state) => state.mode);

  useEffect(() => {
    if(!videoRef.current)return;
    videoRef.current.currentTime = 0;
    if (mode !== PageMode.SILENT) {
      videoRef.current.loop = true;
      videoRef.current.play();
    }else {
      videoRef.current.pause();
    }
  }, [mode]);
  return (
    <video className={styles.video} ref={videoRef} src={getAssetUrl('videos/silent/homeBg.mp4')} autoPlay muted loop />
  );
}

export default HomeBgVideo;